/** Operating systems the Controla App ships a desktop installer for. */
export const DesktopOperatingSystem = {
  Windows: "windows",
  MacOS: "macos",
  Linux: "linux",
} as const;

export type DesktopOperatingSystem =
  (typeof DesktopOperatingSystem)[keyof typeof DesktopOperatingSystem];

/** Operating systems the Controla App ships a mobile installer for. */
export const MobileOperatingSystem = {
  Android: "android",
  IOS: "ios",
} as const;

export type MobileOperatingSystem =
  (typeof MobileOperatingSystem)[keyof typeof MobileOperatingSystem];

export const DesktopAndMobileOperatingSystem = {
  ...DesktopOperatingSystem,
  ...MobileOperatingSystem,
} as const;

export type DesktopAndMobileOperatingSystem =
  (typeof DesktopAndMobileOperatingSystem)[keyof typeof DesktopAndMobileOperatingSystem];

/** Every OS the device inventory can hold, desktop or not. */
export const OperatingSystem = {
  ...DesktopAndMobileOperatingSystem,
  Unknown: "unknown",
} as const;

export type OperatingSystem =
  (typeof OperatingSystem)[keyof typeof OperatingSystem];

export function isMobileOperatingSystem(
  operatingSystem: OperatingSystem | null | undefined,
): operatingSystem is MobileOperatingSystem {
  return (
    operatingSystem != null &&
    Object.values<string>(MobileOperatingSystem).includes(operatingSystem)
  );
}

export function isDesktopOperatingSystem(
  operatingSystem: OperatingSystem | null | undefined,
): operatingSystem is DesktopOperatingSystem {
  return (
    operatingSystem != null &&
    Object.values<string>(DesktopOperatingSystem).includes(operatingSystem)
  );
}

/** Operating systems a device-specific task can be assigned to. */
export type DeviceTaskOperatingSystem =
  DesktopOperatingSystem | MobileOperatingSystem;

export function isDeviceTaskOperatingSystem(
  operatingSystem: OperatingSystem | null | undefined,
): operatingSystem is DeviceTaskOperatingSystem {
  return (
    isDesktopOperatingSystem(operatingSystem) ||
    isMobileOperatingSystem(operatingSystem)
  );
}
